import "friendly-challenge/widget";

/**
 * Key: [data-filter-selector]
 * Value: ['Berlin', 'Köln', ...]
 * @type {{string, [string]}}
 */
const currentFilters = {};

document.querySelectorAll('[data-filter-value]').forEach(function (filterBadge) {
    currentFilters[filterBadge.dataset.filter] = [];

    filterBadge.addEventListener('click', function () {
        const filterType = filterBadge.dataset.filter;
        toggleFilter(filterType, filterBadge.dataset.filterValue);
        updateFilterBadgeActiveState(filterType, filterBadge.dataset.filterValue, filterBadge);

        // De-/Active "All"
        document.querySelector('.ch24-events-noFiltersButton')
            .classList
            .toggle('ch24-badged--active', !currentFilters[filterType] || currentFilters[filterType].length === 0);

        // ToDo: Workaround until we use full frontend filtering logic
        window.location.reload();
    });
});

/**
 * @param {string} filterType
 * @param {string} value
 */
function isFilterActive(filterType, value) {
    return currentFilters[filterType] && currentFilters[filterType].filter(v => v === value).length === 1;
}

/**
 * @param {string} filterType
 * @param {string} filterValue
 * @param {Element|null} filterBadge
 */
function updateFilterBadgeActiveState(filterType, filterValue, filterBadge = null) {
    filterBadge = filterBadge || document.querySelector(`[data-filter="${filterType}"][data-filter-value="${filterValue}"]`);
    filterBadge.classList.toggle('ch24-badged--active', isFilterActive(filterType, filterValue));
}

/**
 * @param {string} filterType
 * @param {string} value
 */
function toggleFilter(filterType, value) {
    const index = (currentFilters[filterType] ?? []).findIndex(v => v === value);

    if (index !== -1) {
        currentFilters[filterType] = currentFilters[filterType].filter(v => v !== value);
    } else {
        currentFilters[filterType] = currentFilters[filterType] || [];
        currentFilters[filterType].push(value);
    }

    refreshFilterableData();
    pushUrlByCurrentFilters();
}

function refreshFilterableData() {
    // Get all node elements which provide filterable data
    const dataFilterTypeSelectors = Object.keys(currentFilters).map(f => `[data-${f}]`).join(',');

    if (!dataFilterTypeSelectors) return

    // Go through them and check if they're still relevant
    for (const filterable of document.querySelectorAll(dataFilterTypeSelectors)) {
        const shouldBeVisible = Object.keys(currentFilters)
            .reduce(
                function (previous, current) {
                    return previous && shouldFilterableVisible(filterable, current);
                },
                true
            );

        updateFilterableState(filterable, shouldBeVisible);
    }
}

/**
 * @param {HTMLElement} filterable
 * @param {string} filterType
 */
function shouldFilterableVisible(filterable, filterType) {
    const filterData = filterable.getAttribute('data-' + filterType);
    if (!filterData) {
        return true;
    }

    if (!filterExists(filterType)) {
        return true;
    }

    for (const filter of currentFilters[filterType] ?? {}) {
        if (filterData.includes(filter)) {
            return true;
        }
    }

    return false;
}

/**
 * @param {Element} filterable
 * @param {boolean} visible
 */
function updateFilterableState(filterable, visible) {
    // filterable.classList.toggle('ch24-filterable-node--filtered', !visible);
}

function filterExists(filterKey) {
    return currentFilters[filterKey]?.length > 0;
}

function pushUrlByCurrentFilters() {
    // Update URL
    const url = new URL(location.origin + location.pathname);

    for (const filterKey in currentFilters) {
        if (!filterExists(filterKey)) {
            continue;
        }

        for (const filterValue of currentFilters[filterKey]) {
            url.searchParams.append(filterKey, filterValue);
        }
    }

    window.history.pushState({}, null, url);
}

function updateFiltersByUrl() {
    const url = new URL(location.href);

    url.searchParams.forEach(function(value, filterType) {
        if (!currentFilters.hasOwnProperty(filterType)) {
            return;
        }

        currentFilters[filterType].push(value);
        updateFilterBadgeActiveState(filterType, value);
    });

    refreshFilterableData();
}

updateFiltersByUrl();

const fileInputs = document.querySelectorAll(".js-validateFileSize");
fileInputs.forEach((fileInput) => {
  fileInput.addEventListener("change", (evt) => {
    if (!evt.target.files) return;
    const file = evt.target.files[0];
    const maxFileSize = 100; // MB
    if (file.size > maxFileSize * 1024 * 1024) {
      evt.preventDefault();
      evt.target.value = "";
      document.getElementById(evt.target.dataset.displayTarget).value = "";
      const errorMessage = document.createElement("p");
      errorMessage.classList.add("text-sm", "text-red-500", "js-error");
      errorMessage.textContent = django.gettext(
        "Die Datei darf maximal 100MB groß sein."
      );
      evt.target.parentElement.parentElement.appendChild(errorMessage);
      return;
    }
    evt.target.parentElement.parentElement.querySelector(".js-error")?.remove();
    document.getElementById(evt.target.dataset.displayTarget).value = file.name;
  });
});
